<template>
  <div class="purchase-button-wrapper">
    <button
      class="purchase-button"
      :class="{ 'is-disabled': disabled, 'is-loading': loading }"
      :disabled="disabled || loading"
      @click="handleClick"
    >
      <span v-if="loading" class="loading-spinner">
        <Icon name="eos-icons:loading" />
      </span>
      <span class="button-text">
        {{ disabled && !loading ? $t('pay.purchase.selectPackage') : $t('pay.purchase.buyNow', { price }) }}
      </span>
    </button>

    <div class="agreement-text">
      {{ $t('pay.purchase.agreementPrefix') }}
      <a href="#" class="agreement-link">{{ $t('pay.purchase.serviceAgreement') }}</a>
      <a href="#" class="agreement-link">{{ $t('pay.purchase.notice') }}</a>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  price: string
  disabled: boolean
  loading: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  click: []
}>()

const handleClick = () => {
  emit('click')
}
</script>

<style scoped lang="scss">
.purchase-button-wrapper {
  margin-top: 32px;
}

.purchase-button {
  width: 100%;
  padding: 16px 32px;
  background: linear-gradient(135deg, #4A90E2 0%, #50E3C2 100%);
  color: white;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);

  &:hover:not(.is-disabled):not(.is-loading) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(74, 144, 226, 0.4);
  }

  &:active:not(.is-disabled):not(.is-loading) {
    transform: translateY(0);
  }

  &.is-disabled {
    background: #ADB5BD;
    cursor: not-allowed;
    box-shadow: none;
  }

  &.is-loading {
    cursor: wait;
  }
}

.loading-spinner {
  font-size: 20px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.button-text {
  white-space: nowrap;
}

.agreement-text {
  margin-top: 12px;
  text-align: center;
  font-size: 13px;
  color: #6C757D;

  .agreement-link {
    color: #4A90E2;
    text-decoration: none;
    margin: 0 4px;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .purchase-button {
    padding: 14px 28px;
    font-size: 16px;
  }
}
</style>
